'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var clipboard = require('pkg/clipboard.js/clipboard');
exports.default = clipboard;